import styled from "styled-components/macro";
import TextButton from "../components/TextButton";

export const CardViewHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .title {
    margin-bottom: 0 !important;
  }

  svg {
    fill: var(--grey-1);
  }
`;

export const CardViewOptions = styled.div`
  position: relative;

  .trigger {
    cursor: pointer;
  }

  .options {
    position: absolute;
    right: 0;
    top: 100%;
    background: var(--menu-color);
    padding: 4px;
    box-shadow: var(--card-drop-shadow);
    border-radius: 12px;
    z-index: 500;
  }

  svg {
    circle {
      fill: var(--grey-1);
    }
  }
`;

export const DeleteButton = styled(TextButton)`
  .text-button-inner {
    color: var(--danger-color);

    svg {
      path {
        fill: var(--danger-color);
      }
    }
  }
`;
